var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgExamSuccess = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1 8.6L11.9 8.8C11.2 8.9 10.5 8.4 10.4 7.7L10.2 5.5H10.3L14.1 8.6Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9 16.7999C15 17.4999 14.4 18.1999 13.7 18.1999L6.69996 18.8999H6.59996H6.39996C5.69996 18.9999 4.99996 18.3999 4.99996 17.6999L3.99996 7.3999C3.89996 6.6999 4.49996 5.9999 5.19996 5.8999L10.2 5.3999H10.3L10.5 7.5999C10.5 7.7999 10.6 7.8999 10.6 8.0999C10.7 8.1999 10.8 8.3999 10.9 8.4999C11.2 8.6999 11.5 8.8999 11.9 8.7999H12.1H12.2L14.1 8.5999L14.9 16.7999Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6 8.5999H14.2H14.1L12.4 8.7999C12.3 8.7999 12.3 8.7999 12.2 8.7999C11.6 8.7999 11.1 8.2999 11 7.6999L10.8 5.8999V5.7999V5.3999H10.9L14.6 8.5999Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9 16.8C15 17.5 14.4 18.2 13.7 18.2L6.7 18.9C6.1 18.9 5.6 18.4 5.5 17.7L4.5 7.3C4.5 6.6 5 6 5.7 5.9L10.2 5.5H10.3H10.6H10.7V5.9V6L11 7.7C11.1 8.3 11.6 8.8 12.2 8.9C12.3 8.9 12.3 8.9 12.4 8.9L14.1 8.7L14.9 16.8Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2 8H14.6C13.8 8 13.1 7.3 13.1 6.5V4L13.2 4.1L17.2 8Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1999 8.1V17.5C17.1999 18.3 16.4999 19 15.6999 19H7.29993C6.49993 19 5.79993 18.3 5.79993 17.5V5.5C5.79993 4.7 6.49993 4 7.29993 4H12.9999H13.0999V6.5C13.0999 7.3 13.7999 8 14.5999 8H17.1999V8.1Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2 8.1V17.5C17.2 18.3 16.5 19 15.7 19H8C7.2 19 6.5 18.3 6.5 17.5V5.5C6.5 4.7 7.2 4 8 4H13H13.1V6.5C13.1 7.3 13.8 8 14.6 8H17.2V8.1Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7 10.5H9.09998C8.79998 10.5 8.59998 10.3 8.59998 10C8.59998 9.7 8.79998 9.5 9.09998 9.5H14.6C14.9 9.5 15.1 9.7 15.1 10C15.1 10.3 14.9 10.5 14.7 10.5Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7 13.3999H9.09998C8.79998 13.3999 8.59998 13.1999 8.59998 12.8999C8.59998 12.5999 8.79998 12.3999 9.09998 12.3999H14.6C14.9 12.3999 15.1 12.5999 15.1 12.8999C15.1 13.1999 14.9 13.3999 14.7 13.3999Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3 15.8H9.09998C8.79998 15.8 8.59998 15.6 8.59998 15.3C8.59998 15 8.79998 14.8 9.09998 14.8H12.2C12.5 14.8 12.7 15 12.7 15.3C12.7 15.6 12.5 15.8 12.3 15.8Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 17.1999C20 18.6999 18.8 19.8999 17.3 19.9999C17.2 19.9999 17.2 19.9999 17.1 19.9999C15.5 19.9999 14.3 18.6999 14.3 17.1999C14.3 15.6999 15.6 14.3999 17.1 14.3999C17.2 14.3999 17.2 14.3999 17.3 14.3999C18.8 14.3999 20 15.5999 20 17.1999Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 17.1999C20 18.6999 18.8 19.8999 17.3 19.9999C17.2 19.9999 17.2 19.9999 17.1 19.9999C15.5 19.9999 14.3 18.6999 14.3 17.1999C14.3 15.6999 15.6 14.3999 17.1 14.3999C17.2 14.3999 17.2 14.3999 17.3 14.3999C18.8 14.3999 20 15.5999 20 17.1999Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3001 19.9999C18.7913 19.9999 20.0001 18.7463 20.0001 17.1999C20.0001 15.6535 18.7913 14.3999 17.3001 14.3999C15.8089 14.3999 14.6001 15.6535 14.6001 17.1999C14.6001 18.7463 15.8089 19.9999 17.3001 19.9999Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8001 18.2C16.7001 18.2 16.7001 18.2 16.6001 18.1L15.8001 17.3C15.7001 17.2 15.7001 17 15.8001 16.9C15.9001 16.8 16.1001 16.8 16.2001 16.9L17.0001 17.7C17.1001 17.8 17.1001 18 17.0001 18.1C16.9001 18.2 16.8001 18.2 16.8001 18.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8001 18.2C16.7001 18.2 16.7001 18.2 16.6001 18.1C16.5001 18 16.5001 17.8 16.6001 17.7L18.1001 16.2C18.2001 16.1 18.4001 16.1 18.5001 16.2C18.6001 16.3 18.6001 16.5 18.5001 16.6L17.0001 18.1C16.9001 18.2 16.8001 18.2 16.8001 18.2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 10.2404,
    y1: 8.87516,
    x2: 11.9412,
    y2: 7.24798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 14.0549,
    y1: 9.4571,
    x2: -4.82514,
    y2: 20.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B82A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 14.5139,
    y1: 4.46674,
    x2: 7.39944,
    y2: 14.5462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 3.2076,
    y1: 6.2148,
    x2: 13.9013,
    y2: 17.8384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B82A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 16.6316,
    y1: 4.6655,
    x2: 11.6484,
    y2: 9.1957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 15.7433,
    y1: 7.965,
    x2: -0.225574,
    y2: 21.2158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 15.8976,
    y1: 2.8784,
    x2: 1.854,
    y2: 32.7776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 1.73938,
    y1: 9.9114,
    x2: 14.8575,
    y2: 10.1189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 1.69478,
    y1: 12.7309,
    x2: 14.8129,
    y2: 12.9385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 1.65568,
    y1: 15.2064,
    x2: 14.7737,
    y2: 15.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 14.313,
    y1: 17.1564,
    x2: 20,
    y2: 17.1564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39BC4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#1FA626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 20.1775,
    y1: 14.6018,
    x2: 12.0799,
    y2: 21.4482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39BC4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#1FA626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 15.0709,
    y1: 14.0947,
    x2: 19.9106,
    y2: 20.6106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39BC4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#1FA626"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExamSuccess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ExamSuccess.d6790f1e.svg";
export { ForwardRef as ReactComponent };